import { SkydioImport } from '../SkydioImport';

type SkydioImportPanelProps = {
  inspectionIds: string[];
  onCloseModal: () => void;
  onComplete?: () => void;
};

export const shouldShowSkydioImport = (canUseSkydioImport: boolean, inspectionIds: string[]) =>
  canUseSkydioImport && inspectionIds.length === 1;

export function SkydioImportPanel({
  inspectionIds,
  onCloseModal,
  onComplete,
}: SkydioImportPanelProps) {
  return (
    <SkydioImport
      inspectionIds={inspectionIds}
      onComplete={() => {
        onComplete?.();
        onCloseModal();
      }}
    />
  );
}
